module.exports = __webpack_public_path__ + "img/icon-hamburger.5bb501e0.jpg";